import Dropzone from "react-dropzone";

import { bytesToSize } from "../../../helpers/general";

// import csvIcon from '../../../assets/icons/file_icons/csv.png'
import { useTranslation } from "react-i18next";
import jpgIcon from "../../../assets/icons/jpg.png";
import pdfIcon from "../../../assets/icons/pdf.png";
import pngIcon from "../../../assets/icons/png.png";

const Upload = ({
  files,
  setFiles,
  multiple = true,
  accept = "audio/*, video/*, image/*, application/*",
  variant = "default", // 'default' or 'button'
  claimDocumentSlots = [],
}) => {
  const { t } = useTranslation();
  const handleAccept = (files) => setFiles(files);
  const handleReject = () => {};
  const setClaimDocumentFile = (slotKey, acceptedFiles) => {
    if (!acceptedFiles.length) {
      return;
    }

    const selectedFile = acceptedFiles[0];
    Object.defineProperty(selectedFile, "uploadSlot", {
      value: slotKey,
      configurable: true,
    });

    const nextFiles = files
      .filter((file) => file.uploadSlot !== slotKey)
      .concat(selectedFile)
      .sort((a, b) => {
        const slotA = claimDocumentSlots.findIndex(
          (slot) => slot.key === a.uploadSlot
        );
        const slotB = claimDocumentSlots.findIndex(
          (slot) => slot.key === b.uploadSlot
        );
        return slotA - slotB;
      });

    setFiles(nextFiles);
  };

  const removeClaimDocumentFile = (slotKey) => {
    setFiles(files.filter((file) => file.uploadSlot !== slotKey));
  };

  const renderUploadedFiles = () => (
    <div
      className="d-flex w-100 flex-column border rounded px-4 py-2"
      style={{ backgroundColor: "inherit" }}
    >
      {files.map((file, index) => (
        <div
          key={index}
          className="d-flex justify-content-between align-items-center"
        >
          <div className="d-flex w-100 flex-row justify-content-between align-items-center py-2">
            {file.type === "image/jpeg" || file.type === "image/jpg" ? (
              <img src={jpgIcon} style={{ width: "30px" }} alt="" />
            ) : file.type === "image/png" ? (
              <img src={pngIcon} style={{ width: "30px" }} alt="" />
            ) : file.type === "application/pdf" ? (
              <img src={pdfIcon} style={{ width: "30px" }} alt="" />
            ) : (
              ""
            )}
            <div className="d-flex flex-column flex-grow-1 ml-4">
              <div>{file.name}</div>
              <small className="text-muted">{bytesToSize(file.size)}</small>
            </div>
          </div>
          <i
            className="fas fa-times"
            onClick={() => setFiles(files.filter((_, i) => i !== index))}
            style={{ cursor: "pointer" }}
          />
        </div>
      ))}
    </div>
  );

  const renderDropzone = () => (
    <Dropzone
      multiple={multiple}
      onDrop={handleAccept}
      onRejected={handleReject}
      accept={accept}
    >
      {({ getRootProps, getInputProps }) => {
        const sharedInput = <input {...getInputProps()} />;
        if (variant === "button") {
          return (
            <div {...getRootProps()} className="upload-vertical-button">
              {sharedInput}
              <div className="upload-icon">
                <i className="fas fa-upload" />
              </div>
              <div className="upload-label">{t("Upload")}</div>
            </div>
          );
        }

        // Default layout
        return (
          <div
            {...getRootProps({
              className:
                "d-flex w-100 flex-column justify-content-center align-items-center rounded text-center p-4",
              style: { border: "2px dashed #e3e3e3" },
            })}
          >
            {sharedInput}
            <i className="fas fa-upload fa-3x text-brand"></i>
            <p className="pt-3">{t("You can also upload files by")}</p>
            <p className="text-brand">{t("Clicking here")}</p>
          </div>
        );
      }}
    </Dropzone>
  );

  const renderClaimDocumentSlots = () => (
    <div className="claim-upload-list">
      {claimDocumentSlots.map((slot, index) => {
        const uploadedFile =
          files.find((file) => file.uploadSlot === slot.key) ||
          (!files[index]?.uploadSlot ? files[index] : null);

        return (
          <Dropzone
            key={slot.key}
            multiple={false}
            onDrop={(acceptedFiles) =>
              setClaimDocumentFile(slot.key, acceptedFiles)
            }
            onRejected={handleReject}
            accept={accept}
          >
            {({ getRootProps, getInputProps }) => (
              <div
                {...getRootProps({
                  className: "claim-upload-card",
                })}
              >
                <input {...getInputProps()} />
                <div className="claim-upload-icon">
                  <i className="fas fa-upload" />
                </div>
                <div className="claim-upload-copy">
                  <div className="claim-upload-title">{t(slot.title)}</div>
                  <div className="claim-upload-description">
                    {t(slot.description)}
                  </div>
                  <div className="claim-upload-hint">
                    {uploadedFile
                      ? `${uploadedFile.name} (${bytesToSize(
                          uploadedFile.size
                        )})`
                      : t("Tap to browse")}
                  </div>
                </div>
                {uploadedFile ? (
                  <button
                    type="button"
                    className="claim-upload-remove"
                    onClick={(event) => {
                      event.stopPropagation();
                      removeClaimDocumentFile(slot.key);
                    }}
                    aria-label={t("Remove file")}
                  >
                    <i className="fas fa-times" />
                  </button>
                ) : (
                  <i className="fas fa-chevron-right claim-upload-chevron" />
                )}
              </div>
            )}
          </Dropzone>
        );
      })}
    </div>
  );

  return (
    <>
      {variant === "claim-documents"
        ? renderClaimDocumentSlots()
        : files && files.length > 0
        ? renderUploadedFiles()
        : renderDropzone()}
    </>
  );
};

export default Upload;
